export type ColorMode = 'light' | 'dark' | 'system';

export const THEME_STORAGE_KEY = '__wb_theme';

export function parseColorMode(userInfo: unknown): ColorMode | null {
  let parsed = userInfo;
  if (typeof userInfo === 'string') {
    try {
      parsed = JSON.parse(userInfo) as unknown;
    } catch {
      return null;
    }
  }
  if (typeof parsed !== 'object' || parsed == null) {
    return null;
  }

  const colorMode = (parsed as {colorMode?: unknown}).colorMode;
  return colorMode === 'light' || colorMode === 'dark' || colorMode === 'system'
    ? colorMode
    : null;
}

export function resolveIsDarkMode(
  colorMode: ColorMode | null,
  storedTheme: string | null,
  systemPrefersDark: boolean
): boolean {
  if (colorMode === 'dark') {
    return true;
  }
  if (colorMode === 'light') {
    return false;
  }
  if (colorMode === 'system') {
    return systemPrefersDark;
  }
  return storedTheme === 'dark';
}

export function applyColorScheme(isDarkMode: boolean): void {
  document.documentElement.style.colorScheme = isDarkMode ? 'dark' : 'light';

  if (isDarkMode) {
    document.documentElement.setAttribute('data-dark-mode', 'true');
  } else {
    document.documentElement.removeAttribute('data-dark-mode');
  }

  try {
    localStorage.setItem(THEME_STORAGE_KEY, isDarkMode ? 'dark' : 'light');
  } catch {}
}
